import { axiosInstance } from '../../interceptor/axios_interceptor'

/**
 * Upload a file to the configured storage provider.
 * @param path  Storage path/key (e.g. "restaurantId/RestaurantImages/photo.jpg")
 * @param file  The File object to upload
 * @returns     The public URL of the uploaded file
 */
export async function uploadFile(path: string, file: File): Promise<string> {
  return _uploadToS3(path, file)
}

/**
 * Delete a file from the configured storage provider.
 * @param path  Storage path/key
 */
export async function deleteFile(path: string): Promise<void> {
  return _deleteFromS3(path)
}

async function _uploadToS3(path: string, file: File): Promise<string> {
  const res = await axiosInstance.post('/api/vendor/storage/presigned-url', {
    path,
    contentType: file.type,
  })

  const { uploadUrl, publicUrl } = res.data

  const uploadRes = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': file.type },
  })

  if (!uploadRes.ok) {
    throw new Error(`Failed to upload to S3: ${uploadRes.statusText}`)
  }

  return publicUrl
}

async function _deleteFromS3(path: string): Promise<void> {
  await axiosInstance.delete('/api/vendor/storage/delete', {
    data: { path },
  });
}
